<template>
<v-main>
  <v-layout class="ma-2" justify-center>
    <v-card class="px-4 rounded-xl" width="1200">
      <v-card-title>
        Cadastrar Recepcionista de Unidade
      </v-card-title>
      <v-divider class="mb-4" />
      <v-form v-model="valid" ref="form">
        <!-- <v-autocomplete
          label="Recepcionistas"
          v-model="idRecepcionistas"
          item-value="id"
          no-data-text="Nenhum recepcionista encontrado"
          :item-text="item => item.nome +' - '+ item.username"
          :rules="[(v) => v && v.length > 0 || 'Você deve escolher um ou mais recepcionistas para cadastrar']"
          :items="listaRecepcionistas"
          required
          multiple
          @input="retornarPossiveisRecepcionista"
        >
  </v-autocomplete> -->
        <v-text-field name="Nome" label="Buscar recepcionista" v-model="search"></v-text-field>
        <v-list two-line>
            <v-list-item-group
              v-model="idRecepcionistas"
              active-class="primary--text"
              multiple
            >
              <template v-for="(item, index) in listaRecepcionistas">
                <v-list-item :value="item.id">
                  <template v-slot:default="{ active }">
                    <v-list-item-content>
                      <!-- Exibe o ID -->
                      <v-list-item-title>
                        {{ item.id }} - {{ item.nome }}
                      </v-list-item-title>

                      <!-- Exibe o Username -->
                      <v-list-item-subtitle>Username: <strong>{{item.username}}</strong></v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-action>
                      <v-icon v-if="!active" color="grey lighten-1">
                        radio_button_unchecked
                      </v-icon>

                      <v-icon v-else color="primary darken-3">
                        radio_button_checked
                      </v-icon>
                    </v-list-item-action>
                  </template>
                </v-list-item>

                <v-divider v-if="index < items.length - 1" :key="index"></v-divider>
              </template>
            </v-list-item-group>
          </v-list>
        <!-- <b-table :data="listaRecepcionistas" :columns="columns"></b-table> -->

        <v-checkbox label="Você concorda?" v-model="checkbox" :rules="[(v) => !!v || 'Você deve concordar para cadastrar']" required></v-checkbox>

        <v-alert :value="errorCadastrar" color="error" icon="warning" outlined>
          Username já existente !!
        </v-alert>

        <v-alert :value="sucessCadastrar" color="success" icon="check_circle" outlined>
          Recepcionista cadastrado com sucesso !!
        </v-alert>
        <v-card-actions>
          <v-spacer />
          <v-btn rounded dark @click="cadastrarRecepcionista" :class="{ red: !valid, green: valid }">cadastrar</v-btn>
          <v-btn rounded outlined to='/listaRecepcionistasUnidade'>
            <v-icon left>keyboard_backspace</v-icon>
            voltar
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-layout>

</v-main>
</template>

<script>
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'cadastrarRecepcionistaUnidade',
  data () {
    return {
      valid: false,
      idLocalEscolhido: undefined,
      tipo: 2,
      errorCadastrar: false,
      sucessCadastrar: false,
      senha: '',
      respostaServidor: '',
      search: '',
      columns: [
        {
          field: 'id',
          label: 'ID',
          numeric: true
        },
        {
          field: 'nome',
          label: 'Nome'
        },
        {
          field: 'username',
          label: 'Username'
        }
      ],
      username: '',
      idRecepcionistas: [],
      listaRecepcionistasCadastradas: [],
      listaRecepcionistas: [],
      nome: '',
      listaLocaisFake: [{
        idLocal: 1,
        nomeLocal: 'sala 12'
      }, {
        idLocal: 1,
        nomeLocal: 'sala 12'
      }],
      listaLocais: [],
      rules: {
        min: v => v.length >= 8 || 'minimo 8 caracteres'
      },
      senhaRules: [
        (v) => (v && v.length > 5) || 'Senha deve ter 6 ou mais caracteres'
      ],
      nameRules: [
        (v) => !!v || 'nome obrigatório',
        (v) => (v && v.length > 7) || 'Username deve ter mais de 7 caracteres '
      ],
      usernameRules: [
        (v) => !!v || 'Username obrigatório',
        (v) => (v && v.length > 7) || 'Username deve ter mais de 7 caracteres '
      ],
      items: [
        'Item 1',
        'Item 2',
        'Item 3',
        'Item 4'
      ],
      checkbox: false

    }
  },
  components: {
    // HelloWorld
  },
  methods: {

    retornarPossiveisRecepcionista (nome) {
      // Limpa a lista ao iniciar uma nova busca
      this.listaRecepcionistas = []

      console.log('Nome digitado:', nome)

      // Verifica se o nome é válido (por exemplo, ter mais de 2 caracteres)
      if (nome < 3) {
        return // Evita chamadas ao backend se o nome for muito curto
      }

      administradorUnidadeService.administradorUnidade
        .retornarPossiveisRecepcionistas(nome)
        .then(rsp => {
          console.log('Resposta da API:', rsp.data)

          // Atualiza a lista de recepcionistas possíveis
          const listaPossiveisRecepcionistas = rsp.data

          // Filtra os recepcionistas que já estão cadastrados
          listaPossiveisRecepcionistas.forEach(possivel => {
            if (!this.listaRecepcionistasCadastradas.find(cadastrado =>
              cadastrado.username === possivel.username
            )) {
              this.listaRecepcionistas.push(possivel)
            }
          })
        })
        .catch(err => {
          // Lida com erros, se necessário
          console.log('Erro ao buscar recepcionistas:', err)
        })
    },

    clear () {
      this.$refs.form.reset()
      this.errorCadastrar = false
    },

    cadastrarRecepcionista () {
      console.log('cadastar')
      if (this.$refs.form.validate()) {
        // get
        console.log('valido')
        administradorUnidadeService.administradorUnidade
          .cadastrarRecepcionista(this.idRecepcionistas)
          .then(rsp => {
            if (rsp.status == 200) {
              if (rsp.data) {
                this.sucessCadastrar = true
                // this.retornarPossiveisRecepcionista()
              } else {
                this.errorCadastrar = true
              }
            }
            console.log('rsp cadastrarRecepcionista:', rsp.data)
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    limpar () {
      this.senha = ''
      this.idUnidadeEscolhida = ''
    }

  },
  created () {
    console.log('created...')
  },
  watch: {
    sucessCadastrar: function (val) {
      setTimeout(() => {
        this.$router.push('/listaRecepcionistasUnidade')
      }, 3000)
    },
    errorCadastrar: function (val) {
      setTimeout(() => {
        this.errorCadastrar = false
      }, 3000)
    },
    search: function (val) {
      this.retornarPossiveisRecepcionista(val)
    }
  },
  mounted () {
    console.log('em mounted lista unid...')
    this.limpar()
    this.user = this.$store.getters.usuario
    if (!this.$route.params.listaRecepcionistasCadastradas) {
      this.$router.push('/listaRecepcionistasUnidade')
      return
    }
    console.log('parametro total recep', this.$route.params.listaRecepcionistasCadastradas)
    this.listaRecepcionistasCadastradas = this.$route.params.listaRecepcionistasCadastradas
    // this.retornarPossiveisRecepcionista()
  }
}
</script>
